import React from "react";
import { Crown, CheckCircle, XCircle  } from "lucide-react";
import RazorpayButton from "../components/RazorpayButton";
import BackHomeButton from "../components/BackHomeButton";

function PremiumUpgradePage() {
  const freeFeatures = [
    "10 Worksheet/Month",
    "10 Quiz/Month",
    "Basic AI Features",
    "Standard Support",
  ];

  const premiumFeatures = [
    "Unlimited Worksheets",
    "Unlimited Quizzes",
    "Advanced AI Tools",
    "Priority Support",
    "500 INR/month"
  ];

  return (
  <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-blue-100 w-full">
  <div className="w-full bg-white rounded-none md:rounded-3xl shadow-2xl overflow-hidden border-0 md:border border-slate-200">       
        {/* Header */}
        <div className="bg-gradient-to-r from-indigo-600 to-blue-600 text-white px-6 py-10 text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-white/20 p-4 rounded-full">
              <Crown className="w-10 h-10" />
            </div>
          </div>

          <h1 className="text-3xl md:text-5xl font-extrabold">
            Upgrade to Eascode Premium
          </h1>

          <p className="mt-4 text-sm md:text-lg text-indigo-100 max-w-2xl mx-auto">
            Unlock unlimited learning tools and give students the best AI-powered
            educational experience.
          </p>
        </div>

        {/* Comparison Section */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-1 p-1 md:p-10">
          
          {/* Free Plan */}
          <div className="border border-slate-200 rounded-2xl p-1 bg-slate-50">
            <h2 className="text-2xl font-bold text-slate-700 mb-6 text-center">
              Free Plan
            </h2>

            <div className="space-y-4">
              {freeFeatures.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-slate-100"
                >
                  <XCircle className="text-red-500 w-5 h-5 flex-shrink-0" />
                  <span className="text-slate-700 font-medium">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Premium Plan */}
          <div className="border-2 border-indigo-500 rounded-2xl p-1 bg-gradient-to-br from-indigo-50 to-blue-50 relative shadow-lg">
            
            <div className="absolute top-10 right-4 bg-indigo-600 text-white text-xs px-3 py-1 rounded-full font-bold">
              BEST VALUE
            </div>

            <h2 className="text-2xl font-bold text-indigo-700 mb-6 text-center">
              Premium Plan
            </h2>

            <div className="space-y-4">
              {premiumFeatures.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-indigo-100"
                >
                  <CheckCircle className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span className="text-slate-800 font-semibold">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <br></br>

        {/* CTA Buttons */}
<div className="px-6 pb-10">
  <div className="grid grid-cols-2 gap-4 max-w-2xl mx-auto">

            <button
              onClick={() => {
                sessionStorage.setItem("showPremiumCampaign", "false");
                window.location.href = "/Old_Home";
              }}
              className="bg-white border-2 border-slate-300 hover:border-indigo-500 hover:text-indigo-600 transition-all text-slate-700 font-bold px-8 py-1 rounded-2xl text-lg"
            >
              Home
            </button>

        {/* Razorpay Button Wrapper */}
        <div className="w-full [&>button]:w-full [&>button]:py-4 [&>button]:rounded-2xl [&>button]:text-lg [&>button]:font-bold">
          <RazorpayButton />
        </div>
            

          </div>
        </div>
      </div>
    </div>
  );
}

export default PremiumUpgradePage;